import { isOneOf } from 'utils/isOneOf';
import type { DeviceViewEdgeEntity } from '../deviceViewTypes';

export const isSourceGroupNode = (
  deviceViewEntity: DeviceViewEdgeEntity,
): boolean => isOneOf(deviceViewEntity.sourceType, 'phoneGroup', 'hostGroup');
